import { isEqual } from 'lodash';

import { BaseModel } from '@Common/Basic/models/base.model';
import { SourceGroupApi } from '../../../api/sourceGroups/models/source-group.api.model';


export class SourceGroup extends BaseModel<SourceGroup, SourceGroupApi> {
    id: number;
    name: string;

    accountId: number;
    sourceIds:  number[];

    createdByUserId: number;
    createdDate: Date;

    lastModifiedByUserId: number;
    lastModifiedDate: Date;

    constructor(apiModel?: SourceGroupApi) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        }
    }

    constructFromApiModel(apiModel: SourceGroupApi) {
        this.id = apiModel.id;
        this.name = apiModel.name;
        this.accountId = apiModel.accountId;
        this.sourceIds = apiModel.sourceIds;
        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = new Date(apiModel.createdDate);
        this.lastModifiedByUserId = apiModel.lastModifiedByUserId;
        this.lastModifiedDate = new Date(apiModel.lastModifiedDate);
    }

    toApiModel(): SourceGroupApi {
        return {
            id: this.id,
            name: this.name,
            accountId: this.accountId,
            sourceIds: this.sourceIds,
            createdByUserId: this.createdByUserId,
            createdDate: +this.createdDate,
            lastModifiedByUserId: this.lastModifiedByUserId,
            lastModifiedDate: +this.lastModifiedDate
        };
    }

    clone(): SourceGroup {
        return new SourceGroup(this.toApiModel());
    }

    equals(other?: SourceGroup): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.name !== other.name) {
            return false;
        }

        if (this.accountId !== other.accountId) {
            return false;
        }

        if (!isEqual(this.sourceIds, other.sourceIds)) {
            return false;
        }

        if (this.createdByUserId !== other.createdByUserId) {
            return false;
        }

        if (this.createdDate !== other.createdDate) {
            return false;
        }

        if (this.lastModifiedByUserId !== other.lastModifiedByUserId) {
            return false;
        }

        if (this.lastModifiedDate !== other.lastModifiedDate) {
            return false;
        }

        return true;
    }

    /** @deprecated Not implemented */
    constructDefault() {}
}
